<template>
  <div
    :class="{ 'dropzone--over': state === 'over' }"
    class="dropzone"
    @dragenter="fileDragEnter"
    @dragleave="fileDragLeave"
    @dragover="fileDragOver"
    @drop="fileDrop"
  >
    <div v-if="state === 'over'" class="dropzone-drop-indicator">
      <i class="icon-file-upload text-primary icon-3x"/>
    </div>

    <div v-if="empty" class="dropzone-placeholder">
      <i class="icon-files-empty icon-3x"/>
    </div>

    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'Dropzone',

    props: {
      empty: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['drop'],

    data() {
      return {
        state: 'idle',
      };
    },

    methods: {
      fileDragEnter(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!event.dataTransfer || !event.dataTransfer.items || !event.dataTransfer.items.length) {
          return;
        }

        for (const item of event.dataTransfer.items) {
          if (item.kind !== 'file') {
            return;
          }
        }

        this.state = 'over';
      },

      fileDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
      },

      fileDragLeave(event) {
        event.preventDefault();
        event.stopPropagation();

        this.state = 'idle';
      },

      fileDrop(event) {
        event.preventDefault();
        event.stopPropagation();

        const validFiles = [];
        for (const file of event.dataTransfer.files) {
          if (file.size <= 0) {
            continue;
          }

          // Folder
          if (file.size % 4096 === 0 && (file.name === '.' || file.fileName === '.')) {
            continue;
          }

          validFiles.push(file);
        }

        if (validFiles.length) {
          this.$emit('drop', validFiles);
        }

        this.state = 'idle';
      },
    },
  };
</script>
